import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AutoCompleteModule } from "primeng/autocomplete";

import { ErrormessageModule } from '../../validation/errormessage/errormessage.module';
import { PCPLotAutoCompleteComponent } from "./pcp-lot-autocomplete.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        AutoCompleteModule,        
        PCPLotAutoCompleteComponent,
    ],
    exports: [PCPLotAutoCompleteComponent]
})
export class PCPLotAutoCompleteModule { }
